import { useMemo } from 'react';
import { Box, Checkbox } from '@nimbus-ds/components';
import { ChargeDto } from '@tiendanube/common';
import { useStoreStatus } from 'domains/Auth/hooks';
import { VIRTUAL_CHARGE_ID } from 'domains/Billing/Checkout/hooks/usePaymentMethods';
import ChargeGroupSkeleton from './Skeleton';
import { useSelectCharges } from '../../hooks';
import ChargeToPay from '../ChargeToPay';

interface ChargeGroupProps {
  charges: ChargeDto[];
}

export default function ChargeGroup({ charges }: Readonly<ChargeGroupProps>) {
  const mainCharge = charges[0];
  const isVirtualCharge = mainCharge.id === VIRTUAL_CHARGE_ID;
  const { selectCharge, selectedCharges, planChargeToUpdate } =
    useSelectCharges(isVirtualCharge);

  const { storeStatus } = useStoreStatus();
  const isPlan = mainCharge.conceptCode === 'plan-cost';
  const forceSelection =
    mainCharge.status === 'IN_PROCESS' ||
    (isPlan && (storeStatus === 'admin_down' || storeStatus === 'store_down'));

  const isSelected = useMemo(
    () => selectedCharges.some(({ id }) => mainCharge.id === id),
    [selectedCharges, mainCharge],
  );

  return (
    <Box
      display="flex"
      flexDirection="row"
      padding="4"
      justifyContent="space-between"
      alignItems="baseline"
      gap="2"
    >
      <Box display="flex" flex="1 1 3%" justifyContent="flex-start">
        <Box>
          <Checkbox
            name={`checkbox-charge-${charges[0].id}`}
            checked={isSelected}
            onChange={(e) => selectCharge(e.target.checked, charges)}
            disabled={forceSelection}
          />
        </Box>
      </Box>
      <Box display="flex" flexDirection="column" flex="1 1 97%" gap="6">
        {charges.map((charge) => (
          <ChargeToPay
            key={charge.id}
            charge={charge}
            isPlanChargeToUpdate={charge.id === planChargeToUpdate?.id}
          />
        ))}
      </Box>
    </Box>
  );
}

ChargeGroup.Skeleton = ChargeGroupSkeleton;
